// extracted by mini-css-extract-plugin
export default {"sliderTitle":"Portfolio_sliderTitle__Ngm-M","card":"Portfolio_card__9aAqa","cardBtn":"Portfolio_cardBtn__Bwcb5"};